import React, { Component } from 'react';
import { connect } from 'react-redux';
import ultimatePagination, { ITEM_TYPES } from 'ultimate-pagination';

import { setPage, performSearch } from './actions.mjs';

class Pagination extends Component {
  changePage(page) {
    window.scrollTo(0, 0);
    document.activeElement.blur();
    this.props.dispatch(setPage(page));
  }

  render() {
    if (this.props.results.total === 0) {
      return null;
    }

    const resultsPerPage = 10;
    const pages = Math.ceil(this.props.results.total / resultsPerPage);

    if (!(this.props.results.total > resultsPerPage)) {
      return null;
    }

    let siblingPagesRange = 4;

    if (window.innerWidth < 1024) {
      siblingPagesRange = 2;
    }

    let range = ultimatePagination.getPaginationModel({
      currentPage: this.props.page,
      totalPages: pages,
      boundaryPagesRange: 0,
      siblingPagesRange,
      hideEllipsis: true,
      hidePreviousAndNextPageLinks: false,
      hideFirstAndLastPageLinks: true,
    });

    return (
      <div className="search-page__pagination">
        <div className="search-page__pagination-inner">
          {range.map(page => {
            let className = 'search-page__pagination-page';
            if (page.isActive) {
              className =
                'search-page__pagination-page search-page__pagination-page--active';
            }
            if (
              page.type === ITEM_TYPES.PREVIOUS_PAGE_LINK ||
              page.type === ITEM_TYPES.NEXT_PAGE_LINK
            ) {
              className =
                'search-page__pagination-page search-page__pagination-page--is-navigation';
            }
            if (
              page.isActive &&
              (page.type === ITEM_TYPES.PREVIOUS_PAGE_LINK ||
                page.type === ITEM_TYPES.NEXT_PAGE_LINK)
            ) {
              className =
                'search-page__pagination-page search-page__pagination-page--is-navigation search-page__pagination-page--is-inactive';
            }
            if (page.type === ITEM_TYPES.PREVIOUS_PAGE_LINK) {
              return (
                <button
                  onClick={() => this.changePage(page.value)}
                  className={className}
                  key={page.key}
                >
                  <i className="fa fa-angle-left" />&nbsp;&nbsp;{
                    <span className="search-page__pagination-page-text">
                      {this.props.translations.previous}
                    </span>
                  }
                </button>
              );
            } else if (page.type === ITEM_TYPES.NEXT_PAGE_LINK) {
              return (
                <button
                  onClick={() => this.changePage(page.value)}
                  className={className}
                  key={page.key}
                >
                  <span className="search-page__pagination-page-text">
                    {this.props.translations.next}
                  </span>&nbsp;&nbsp;<i className="fa fa-angle-right" />
                </button>
              );
            } else {
              return (
                <button
                  onClick={() => this.changePage(page.value)}
                  className={className}
                  key={page.key}
                >
                  {page.value}
                </button>
              );
            }
          })}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    translations: state.translations,
    results: state.results,
    page: state.page,
  };
};

export default connect(mapStateToProps)(Pagination);
